<script>
import Cookies from "js-cookie";
import {notificationMethods, userMethods} from "@/state/helpers";
import { required, email } from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import appConfig from "@/app.config";
import Multiselect from 'vue-multiselect'

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Users",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast,
    Multiselect
  },
  data() {
    return {
      roleOptions: ['user','admin','lms'],
      toastAction:'',
      toastMessage:'',
      showToast:false,
      itemsLoaded: false,
      items: [],
      currentUser:JSON.parse(Cookies.get('user')),
      users: [],
      title: "Kullanıcılar Tablosu",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Kullanıcılar",
        },
      ],
      addSubmitted: false,
      editSubmitted: false,
      showModal: false,
      editModal: false,
      deleteModal: false,
      noDeleteModal:false,
      addForm: {
        username:"",
        name: "",
        email: "",
        password: "",
        status:true,
        role:[]
      },
      editForm: {
        username:"",
        name: "",
        email: "",
        role:[],
        status:''
      },
      editId: "",
      deleteId: "",
      totalRows: 1,
      page: 1,
      perPage: 10,
      search:'',
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "name",
          sortable: true,
          label:'Ad Soyad',
        },
        {
          key: "email",
          label:'E-Posta',
          sortable: true,
        },{
          key: "role",
          label: "Rol",
          sortable: true,
        },
        {
          key: "createdAt",
          label:'Oluşturulma Tarihi',
          sortable: true,
        },
        {
          key: "status",
          label:'Aktiflik Durumu',
          sortable: true,
        },

        {
          key: "edit",
          label: "Düzenle",
        },
        {
          key: "delete",
          label: "Sil",
        },
      ],
      pageInput:1
    };
  },
  validations: {
    addForm: {
      username:{required},
      name: { required },
      email: { required, email },
      password:{required},
      role:{required},
      status:{required}
    },
    editForm: {
      username:{required},
      name: { required },
      email: { required, email },
      role:{required},
      status:{required}
    },
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.items.length;
    },
    totalPages() {
      return Math.ceil(this.totalRows / this.perPage);
    },
  },
  watch:{
    page(newPage){
      this.pageInput=newPage;
      this.getUsers(newPage);
    },
    search(newSearch){
      if(newSearch.length<1){
        if(this.page===1){
          this.getUsers();
        }else{
          this.page=1;
        }
      }
    },
    'addForm.email':function(){
      this.addForm.email= this.addForm.email.toLowerCase()
    },
    'editForm.email':function(){
      this.editForm.email= this.editForm.email.toLowerCase()
    }
  },
  mounted() {
    this.getUsers();
    this.resetAddForm();
  },
  methods: {
    ...userMethods,
    ...notificationMethods,
    doSearch(){
      if(this.page===1){
        this.getUsers();
      }else{
        this.page=1;
      }
    },
    resetForm() {
      this.addForm = {
        username:null,
        name: null,
        email: null,
        password:null,
        status:null,
        role:null
      };
      this.addSubmitted = false;
    },
    getUsers(page=this.page){
      this.itemsLoaded=false;
      this.fetchUsers({page,limit:this.perPage,search:this.search}).then(res=>{
        this.totalRows = res.total;
        // getting category ready for fields
        this.items = res.docs.map(elem=>{
          return elem;
        })
        this.itemsLoaded=true;
      })
    },
    handleSubmit() {
      this.addSubmitted = true;
      this.$v.addForm.$touch();
      if (this.$v.addForm.$invalid) {
        return;
      }else {
        this.createUser(this.addForm).then(() => {
          this.toastMessage = "Kullanıcı başarıyla eklendi!";
          this.toastAction = "success";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 3000);
          this.showModal = false;
          this.getUsers();
          this.addForm.name = "";
          this.addForm.role = "";
          this.addForm.username = "";
          this.addForm.email = "";
          this.addForm.password = "";
          this.addForm.status = true;
        });
      }
    },
    handleEditSubmit() {
      this.editSubmitted = true;
      this.$v.editForm.$touch();
      if (
          this.$v.editForm.$invalid
      ) {
        return;
      } else {
        this.updateUser({id:this.editId,data:this.editForm}).then(()=>{
          this.toastMessage="Kullanıcı başarıyla düzenlendi!";
          this.toastAction="success";
          this.showToast=true;
          setTimeout(()=>{
            this.showToast=false;
          },3000)
          this.editModal = false;
          this.getUsers();
        })
      }
    },
    handleDeleteSubmit() {
      this.deleteUser(this.deleteId).then(()=>{
        this.deleteModal = false;
        this.toastMessage="Kullanıcı başarıyla silindi!";
        this.toastAction="success";
        this.showToast=true;
        setTimeout(()=>{
          this.showToast=false;
        },3000)
        this.getUsers();
      })
    },
    openEdit(user) {
      this.editForm.name =user.name;
      this.editForm.username = user.username;
      this.editForm.email = user.email;
      this.editForm.role = user.role;
      this.editForm.status = user.status;
      this.editId = user.id;
      this.editModal = true;
    },
    openDelete(user) {
      if(user.email===this.currentUser.email){
        this.noDeleteModal=true;
      }else{
        this.deleteId = user.id;
        this.deleteModal = true;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems" />
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Ara:
                    <b-form-input
                        v-model="search"
                        @keyup.enter="doSearch"
                        type="search"
                        placeholder="ara..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>

                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="showModal = true;  resetForm();"
                >
                  Kullanıcı Ekle
                </button>
              </div>
            </div>

            <!-- Table -->
            <div v-if="itemsLoaded">
              <div class="table-responsive mb-0">
                <b-table
                    class="datatables"
                    :items="items"
                    :fields="fields"
                    :sort-by="sortBy" :sort-desc="sortDesc" @sort-changed="onSortChanged"
                    responsive="sm"
                >
                  <template v-slot:cell(createdAt)="data">
                    {{data.item.createdAt| formatDate}}
                  </template>

                  <template v-slot:cell(role)="data">
                    <ul>
                      <li v-for="role in data.item.role" :key="role">{{ role }}</li>
                    </ul>
                  </template>


                  <template v-slot:cell(status)="data">
                    <td v-if="data.item.status" class="align-middle">
                      <span class="badge badge-pill badge-soft-success font-size-14">Aktif</span>
                    </td>
                    <td v-else class="align-middle">
                      <span class="badge badge-pill badge-soft-danger font-size-14">Pasif</span>
                    </td>
                  </template>

                  <template v-slot:cell(edit)="data">
                    <button
                        class="btn btn-warning d-flex py-2"
                        @click="openEdit(data.item)"
                    >
                      <i :class="`bx bxs-edit bx-xs`"></i>
                    </button>
                  </template>
                  <template v-slot:cell(delete)="data">
                    <button
                        class="btn btn-danger d-flex py-2"
                        @click="openDelete(data.item)"
                    >
                      <i :class="`bx bx-trash bx-xs`"></i>
                    </button>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                      class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <input :style="{width:'40px', maxWidth:'100%', display:'flex',justifyContent:'center', marginTop:'-3px'}" @keyup.enter="page=pageInput" v-model="pageInput" type="text"  class="form-control">
                      <b-pagination
                          v-model="page"
                          :total-rows="totalRows"
                          :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                  <div class="page-info mt-2"> Toplam sayfa sayısı {{ totalPages }}</div>
                </div>
              </div>
            </div>
            <div class="spinner-wrapper" v-else>
              <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
            </div>


          </div>
        </div>
      </div>
      <b-modal v-model="showModal" title="Kullanıcı Ekle" hide-footer>
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="name">Ad</label>
                <input
                    id="name"
                    type="text"
                    v-model="addForm.name"
                    class="form-control"
                    placeholder="Ad giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.name.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.name.required"
                    class="invalid-feedback"
                >
                  Ad girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="username">Kullanıcı Adı</label>
                <input
                    id="username"
                    type="text"
                    v-model="addForm.username"
                    class="form-control"
                    placeholder="Kullanıcı adı giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.username.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.username.required"
                    class="invalid-feedback"
                >
                  Kullanıcı adı girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="email">Email</label>
                <input
                    name="email"
                    id="email"
                    type="email"
                    autocomplete="off"
                    v-model="addForm.email"
                    class="form-control"
                    placeholder="Email giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.email.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && $v.addForm.email.$error"
                    class="invalid-feedback"
                >
                  <span v-if="!$v.addForm.email.required">Email girilmesi gerekli bir alandır.</span>
                  <span v-if="!$v.addForm.email.email">Lütfen geçerli bir email giriniz.</span>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="password">Şifre</label>
                <input
                    name="password"
                    id="password"
                    type="password"
                    v-model="addForm.password"
                    class="form-control"
                    placeholder="Şifre giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.password.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.password.required"
                    class="invalid-feedback"
                >
                  Şifre girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>


            <div class="col-12">
              <div class="mb-3" :class="{
    'is-invalid': addSubmitted && $v.addForm.role.$error,
  }">
                <label for="roles">Rolleri Seçin</label>
                <multiselect
                    v-model="addForm.role"
                    :options="roleOptions"
                    placeholder="Rolleri seçin"
                    multiple
                    :select-label="'Seçiniz'"
                    :selected-label="'Kaldır'"
                    :selected-text="'Kaldır'"
                ></multiselect>
              </div>
              <div
                  v-if="addSubmitted && $v.addForm.role.$error"
                  class="invalid-feedback mb-2" style="margin-top:-12px"
              >
                Rol seçimi gerekli bir alandır.
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="status">Aktiflik Durumu</label>
                <select name="status"
                        v-model="addForm.status"
                        class="form-control">
                  <option :value="true">Aktif</option>
                  <option :value="false">Pasif</option>
                </select>
              </div>
            </div>


          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showModal = false; resetForm();"
            >Vazgeç</b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Kullanıcı Ekle</b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal v-model="editModal" title="Kullanıcı Düzenle" hide-footer>
        <form @submit.prevent="handleEditSubmit" autocomplete="off">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="name">Ad</label>
                <input
                    id="name"
                    type="text"
                    v-model="editForm.name"
                    class="form-control"
                    placeholder="Ad giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.editForm.name.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.editForm.name.required"
                    class="invalid-feedback"
                >
                  Ad girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="username">Kullanıcı Adı</label>
                <input
                    id="username"
                    type="text"
                    v-model="editForm.username"
                    class="form-control"
                    placeholder="Kullanıcı adı giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.editForm.username.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.editForm.username.required"
                    class="invalid-feedback"
                >
                  Kullanıcı adı girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="email">Email</label>
                <input
                    name="email"
                    id="email"
                    type="email"
                    autocomplete="off"
                    v-model="editForm.email"
                    class="form-control"
                    placeholder="Email giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.editForm.email.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && $v.editForm.email.$error"
                    class="invalid-feedback"
                >
                  <span v-if="!$v.editForm.email.required">Email girilmesi gerekli bir alandır.</span>
                  <span v-if="!$v.editForm.email.email">Lütfen geçerli bir email giriniz.</span>
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="mb-3" :class="{
    'is-invalid': editSubmitted && $v.editForm.role.$error,
  }">
                <label for="roles">Rolleri Seçin</label>
                <multiselect
                    v-model="editForm.role"
                    :options="roleOptions"
                    placeholder="Rolleri seçin"
                    multiple
                    :select-label="'Seçiniz'"
                    :selected-label="'Kaldır'"
                    :selected-text="'Kaldır'"
                ></multiselect>
              </div>
              <div
                  v-if="editSubmitted && $v.editForm.role.$error"
                  class="invalid-feedback mb-2" style="margin-top:-12px"
              >
                Rol seçimi gerekli bir alandır.
              </div>
            </div>

            <div class="col-12">
              <div class="mb-3">
                <label for="status">Aktiflik Durumu</label>
                <select name="status"
                        v-model="editForm.status"
                        class="form-control">
                  <option :value="true">Aktif</option>
                  <option :value="false">Pasif</option>
                </select>
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="editModal = false"
            >Vazgeç</b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Kullanıcı Düzenle</b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal
          v-model="deleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu kullanıcıyı silmek istediğinize emin misiniz? Silinmiş kullanıcıları geri alamazsınız.
              </p>

              <form @submit.prevent="handleDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
          v-model="noDeleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Silinemez !</h4>
              <p class="text-muted font-size-14 mb-4">
                Oturumunu açtığınız kullanıcıyı silemezsiniz.
              </p>
            </div>
          </div>
        </div>
      </b-modal>
    </div>

  </Layout>
</template>
<style scoped>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}
.pill span {
  padding: 6px 12px 4px 12px;
}
</style>
